var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "32px",
    viewBox: "0 0 28 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeThumbsUp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.4709201%",
    y1: "0%",
    x2: "61.8674045%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64DF9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F093FD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page-Pass-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-226.000000, -681.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "how-it-works",
    transform: "translate(0.000000, 607.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "contents",
    transform: "translate(221.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ThumbsUp",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33350321,15.9995888 L4.02110911,15.9995888 C4.84913122,15.9997102 5.63025268,15.6152702 6.13526132,14.959079 L11.4498078,8.05256851 C11.8085077,7.58645487 12.0030422,7.01482796 12.0031287,6.42667194 L12.0031287,1.33345376 C11.9978602,0.978181202 12.1366956,0.635919432 12.3879765,0.384713862 C12.6392575,0.133508293 12.9815609,-0.00522447794 13.3368318,0.000150567812 C15.0477931,0.000150567812 17.337808,2.00010535 17.337808,6.00001492 C17.4245996,8.3339656 17.0519025,10.6622242 16.2408995,12.85246 C16.1918328,12.9557002 16.1985846,13.0767982 16.2588239,13.173944 C16.3190632,13.2710898 16.4245357,13.330972 16.5388261,13.3329158 L25.2309629,13.3329158 C26.5772241,13.3100939 27.740808,14.2682348 27.9767008,15.5938647 C28.1465653,16.7050768 27.597315,17.8026423 26.6060652,18.3328028 C27.5345622,18.8284076 28.0813352,19.82691 27.9987877,20.8761559 C27.9162402,21.9254017 27.2200497,22.8261162 26.2254738,23.1704267 C26.7103812,23.5127145 27.0646926,24.0095121 27.2303844,24.5794615 C27.4023263,25.224186 27.326055,25.9099613 27.0166559,26.5011514 C26.6600336,27.3407729 25.8582381,27.9056232 24.9475693,27.9587851 C25.2340621,28.4230692 25.3689635,28.9650047 25.3335606,29.5094167 C25.1842088,30.946058 23.9587816,32.0285226 22.514691,31.9994271 L12.5659826,31.9994271 C10.4596376,31.9994759 8.40038874,31.3761597 6.64764973,30.2080009 L6.00646423,29.7806773 C5.56829995,29.4886678 5.05351679,29.3328619 4.52696434,29.3328874 L1.33370321,29.3328874 C0.980019917,29.3329935 0.640786266,29.1925677 0.390656897,28.9425134 C0.140527528,28.692459 1.07919807e-08,28.3532675 2.67077296e-08,27.9995842 L2.67077296e-08,17.3331587 C-7.0716243e-05,16.9794638 0.14039812,16.6402341 0.390491897,16.3901279 C0.640585675,16.1400216 0.979808362,15.9995358 1.33350321,15.9995888 Z",
    id: "HomeThumbsUp"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeThumbsUp);
export default __webpack_public_path__ + "static/media/HomeThumbsUp.a38b6849307bde787dacb47b49f295d8.svg";
export { ForwardRef as ReactComponent };